import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@material-ui/core'
import linkTypes from './enums/linkTypes'
import Collection from './components/Collection'
import icons from './enums/icons'
import Icon from './components/Icon'
import FixedSizeImage from './components/FixedSizeImage'
import connectPropTypes from './utilities/connectPropTypes'
import { notificationDisplay } from './utilities/Data/Notification'
import styles from './Notifications.icss'

const renderAfterItem = renderProps => (
	renderProps && renderProps.item && renderProps.item.images ? <FixedSizeImage className={styles.image} content={renderProps.item.images} /> : null
)

const limitNotifications = 20

class Notifications extends React.Component {
	componentDidMount() {
		this.props.appHeading({
			text: this.context.translate('Notifications'),
			icon: icons.whiteComments
		})
		this.props.appBottomBarValue(linkTypes.NOTIFICATIONS)
		//	 Add startAfterTimestamp when clicking the more button
		this.props.notificationsFetch({ uid: this.props.user.uid })
		this.moreClickHandler = this.moreClickHandler.bind(this)
	}

	componentDidUpdate(prevProps) {
		if (prevProps.notifications !== this.props.notifications) {
			this.props.notificationsSeenSet({ notifications: this.props.notifications })
		}
	}

	moreClickHandler() {
		const notifications = this.props.notifications
		this.props.notificationsMoreFetch({ uid: this.props.user.uid, startAfterTimestamp: notifications[notifications.length - 1].createdTimestamp })
	}

	render() {
		const { notifications } = this.props
		return (
			<>
				{notifications && (
					<section>
						<Collection
							items={notifications}
							itemTitle={u => <span className={styles.title}>{notificationDisplay[u.notificationType].title(u)}</span>}
							itemSubtitle={u => <span className={styles.subTitle}><Icon name={notificationDisplay[u.notificationType].iconName} /> <span className={styles.subTitleText}>{notificationDisplay[u.notificationType].subTitle(u)}</span></span>}
							itemImageContent={u => u.fromImages}
							itemHref={u => u.link}
							itemImageCover
							renderAfterItem={renderAfterItem}
						/>
						{notifications.length === limitNotifications && (
							<Button variant="contained" fullWidth onClick={this.moreClickHandler} className={styles.moreButton}>
								{this.context.translate('Load more notifications')}
							</Button>
						)}
					</section>
				)}
			</>
		)
	}
}

Notifications.contextTypes = {
	translate: PropTypes.func
}

Notifications.propTypes = {
	user: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
	notifications: PropTypes.array, // eslint-disable-line react/forbid-prop-types
	appHeading: PropTypes.func.isRequired,
	appBottomBarValue: PropTypes.func.isRequired,
	notificationsFetch: PropTypes.func.isRequired,
	notificationsMoreFetch: PropTypes.func.isRequired,
	notificationsSeenSet: PropTypes.func.isRequired
}

Notifications.defaultProps = {
	notifications: undefined
}

export const testing = {
	Notifications
}

export default connectPropTypes(Notifications)



// WEBPACK FOOTER //
// ./src/Notifications.jsx